import classNames from 'classnames';

import { FavoriteIcon, FavoriteFilledIcon } from '../../icons';

import styles from './_index.module.scss';

export interface FavoriteToggleProps {
  isFavorite?: boolean;
  onChange?: () => void;
}

const FavoriteToggle = ({ isFavorite, onChange = () => {} }: FavoriteToggleProps) => (
  <span className={classNames({ [styles['is-favorite']]: isFavorite })} onClick={() => onChange()}>
    {isFavorite ? <FavoriteFilledIcon /> : <FavoriteIcon />}
  </span>
);

export default FavoriteToggle;
